import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../action-button';

const defaultCaptions = {
  back: 'Back',
  skip: 'Skip',
};

const OnboardingHeader = ({ captions = defaultCaptions, logo, onBack = null, onSkip = null }) => (
  <div className="ws-ui-onboarding-header">
    {onBack && (
      <ActionButton format="text" iconGlyph="back" onClick={onBack} label={captions.back} />
    )}
    <div
      className="ws-ui-onboarding-header__logo"
      style={{ width: logo.width, height: logo.height }}
    >
      {logo.src && <img src={logo.src} width={logo.width} height={logo.height} alt={logo.alt} />}
    </div>
    {onSkip && <ActionButton format="text" onClick={onSkip} label={captions.skip} />}
  </div>
);

OnboardingHeader.propTypes = {
  captions: PropTypes.shape({
    back: PropTypes.string,
    skip: PropTypes.string,
  }),
  logo: PropTypes.shape({
    src: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    alt: PropTypes.string,
  }).isRequired,
  onBack: PropTypes.func,
  onSkip: PropTypes.func,
};

export default OnboardingHeader;
